import { render, staticRenderFns } from "./sim-infos.vue?vue&type=template&id=700a8a4a&scoped=true"
import script from "./sim-infos.vue?vue&type=script&lang=js"
export * from "./sim-infos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700a8a4a",
  null
  
)

export default component.exports